module.exports = __webpack_public_path__ + "img/coder.91e1d97d.svg";